G.WorldMapLastLevel = function(map, x, y) {
  Phaser.Group.call(this, game);
  
  this.map = map;
  this.position = this.map.position;

  this.mainGroup = this.add(game.add.group());
  this.mainGroup.y = y;

  if (game.state.current === 'World') {
    this.addClouds();
    this.addGate(x, 0);
    this.addMessage(0, -250);
  }

};

G.WorldMapLastLevel.prototype = Object.create(Phaser.Group.prototype);

G.WorldMapLastLevel.prototype.update = function() {
  this.visible = this.map.y + this.mainGroup.y > -20;  
};

G.WorldMapLastLevel.prototype.addClouds = function() {

  this.cloud1 = G.makeImage(-450,-360,'cloud_1',0.5,this.mainGroup);
  this.cloud1.scale.setTo(2);
  this.c1tween = game.add.tween(this.cloud1.scale).to({x:2.1,y:2.1},4000,Phaser.Easing.Sinusoidal.InOut,true,0,-1,true);
  this.c1tween.timeline[0].dt = 2000;
  this.cloud1.alpha = 0.95;

  this.cloud2 = G.makeImage(0,-410,'cloud_1',0.5,this.mainGroup);
  this.cloud2.scale.setTo(2);
  this.c2tween = game.add.tween(this.cloud2.scale).to({x:2.1,y:2.1},8000,Phaser.Easing.Sinusoidal.InOut,true,0,-1,true);
  this.c2tween.timeline[0].dt = 3000;
  this.cloud2.alpha = 0.95;

  this.cloud3 = G.makeImage(450,-360,'cloud_1',0.5,this.mainGroup);
  this.cloud3.scale.setTo(-2,2); 
  this.c3tween = game.add.tween(this.cloud3.scale).to({x:-2.1,y:2.1},6000,Phaser.Easing.Sinusoidal.InOut,true,0,-1,true);
  this.c3tween.timeline[0].dt = 1500;
  this.cloud3.alpha = 0.95;

};

G.WorldMapLastLevel.prototype.addGate = function(x, y) {
  this.gate = G.makeImage(x, y, "gate", [0.5, 1], this.mainGroup);
  this.gateLock = G.makeImage(0, -15, "lock", 0.5, this.gate);
};

G.WorldMapLastLevel.prototype.addMessage = function(x, y) {
  this.msg = G.makeImage(x, y, "MysteryGift_header", 0.5, this.mainGroup);
  this.msgTxt = this.msg.addChild(new G.Text(
    0, 0, OMT.language.getText("More levels coming soon..."), {
      style: "font-purple",
      fontSize: 40,
    }, 0.5, 400));
  game.add.tween(this.msg)
    .to({y: y+10}, 1500, Phaser.Easing.Sinusoidal.InOut, true, 0, -1, true);
};